import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import store from '../store'
import router from '../router'
import notification from '../helpers/notification'

async function logout() {
  await store.dispatch('authentication/logout')
  const {fullPath} = router.currentRoute
  const loginRoute = {
    path: '/login',
  }

  if (fullPath != '/login') {
    loginRoute.query = {
      returnUrl: fullPath,
    }
  }

  router.push(loginRoute)

  notification('Your session expired, please login again')
}

async function requestToken() {
  const {'authentication/tokenString': tokenString, 'authentication/token': token} = store.getters
  if (token) {
    if (store.getters['authentication/refreshToken']) {
      await store.dispatch('authentication/startRefreshTokenInterval', {immediate: true})
    }

    console.log(axios.defaults.headers.common['Authorization'])

    const expiration = new Date(token.exp * 1000)
    const now = new Date().getTime()
    if (now > expiration) {
      if (store.getters['authentication/refreshToken']) {
        await store.dispatch('authentication/getNewAccessToken')
      } else {
        await logout()
      }
    }
  }
  if (tokenString) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${tokenString}`
  }
}

requestToken()

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(axios, requestToken)

kendo.jQuery.ajaxSetup({
  // Inject the JWT token to kendo jQuery dependence
  beforeSend: xhr => {
    const tokenString = store.getters['authentication/tokenString']
    if (tokenString) {
      xhr.setRequestHeader('Authorization', `Bearer ${tokenString}`)
    }
  },
  statusCode: {
    // Logout if 401 responses are caught on kendo
    401: async function() {
      if (!store.getters['authentication/refreshToken']) {
        return logout()
      }
      await requestToken()
      kendo.jQuery.ajax(this)
    },
  },
})

// Logout if 401 responses are caught on axios
axios.interceptors.response.use(undefined, function(err) {
  return new Promise(function(resolve, reject) {
    if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
      resolve()
      logout()
    }
    reject(err)
  })
})
